export default __webpack_public_path__ + "static/media/ic_liq.ed6c5413.svg";